import { UnusableReason } from "gen/ApiClient";

export const UnusableReasonRecord: Record<UnusableReason, string> = {
    Other: 'Andere',
    Sold: 'Verkocht',
    Stolen: 'Gestolen',
}